import { render, staticRenderFns } from "./index.vue?vue&type=template&id=2e18f22f&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=2e18f22f&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e18f22f",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e18f22f')) {
      api.createRecord('2e18f22f', component.options)
    } else {
      api.reload('2e18f22f', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=2e18f22f&scoped=true", function () {
      api.rerender('2e18f22f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-business/user/position/index.vue"
export default component.exports